(() => {
  'use strict';
  // Only Shopify's server-confirmed success marker counts as a conversion.
  // No email, name, phone, inquiry text or other contact fields are collected.
  const forms = {
    CabanaContactForm: 'contact',
    CabanaCustomProcessForm: 'custom_design',
    CabanaTradeForm: 'trade',
    CabanaNewsletterForm: 'newsletter',
    BespokeTableForm: 'bespoke_table'
  };
  const key = kind => 'cabana:pending-form:' + kind;
  const maxAge = 30 * 60 * 1000;
  document.querySelectorAll('[data-cabana-form-success]').forEach(marker => {
    const kind = marker.getAttribute('data-cabana-form-success');
    if (!Object.values(forms).includes(kind)) return;
    try {
      const raw = sessionStorage.getItem(key(kind));
      sessionStorage.removeItem(key(kind));
      if (!raw) return;
      const pending = JSON.parse(raw);
      const age = Date.now() - pending.time;
      if (age < 0 || age > maxAge || typeof pending.id !== 'string') return;
      const event = kind === 'newsletter' ? 'sign_up' : 'generate_lead';
      const params = { form_type: kind, event_id: pending.id };
      if (kind === 'newsletter') params.method = 'newsletter';
      if (typeof window.gtag === 'function') {
        window.gtag('event', event, params);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event, ...params });
      }
    } catch (_) { /* Analytics must never block the form. */ }
  });
  document.addEventListener('submit', event => {
    const kind = forms[event.target.id] || event.target.getAttribute('data-cabana-form-type');
    if (!Object.values(forms).includes(kind) || event.defaultPrevented) return;
    try {
      const id = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2);
      sessionStorage.setItem(key(kind), JSON.stringify({ id, time: Date.now() }));
    } catch (_) { /* Disabled storage must never block submission. */ }
  });
})();
